import {
  type UserConstructorData,
  User,
} from '@webapp/core/entities/internal/User'

export interface CommentConstructorData {
  id: number
  message: string
  submittedAt: ISODateString
  author: UserConstructorData
}

export class Comment {
  id: number
  message: string
  submittedAt: Date
  author: User

  constructor(data: CommentConstructorData) {
    this.id = data.id
    this.message = data.message
    this.submittedAt = new Date(data.submittedAt)
    this.author = new User(data.author)
  }

  isAuthoredBy(userId: number) {
    return this.author.id === userId
  }
}
